<template>
  <div class="avatar">
    <div v-if="photo != ''" class="photo-mode"></div>
    <div
      v-if="photo == ''"
      class="letter-mode"
      :style="{ backgroundColor: textToColor(letters) }"
    >
      {{ letters }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: ['name', 'photo'],
  computed: {
    letters() {
      if (this.name[0] == '+') return this.name;

      const name = this.name.split(' ');
      const first_letter = name[0].substring(0, 1).toUpperCase();
      const last_letter = name[name.length - 1].substring(0, 1).toUpperCase();

      return first_letter + last_letter;
    }
  },
  methods: {
    textToColor(text) {
      const colors = [
        '#a172b1',
        '#3076ae',
        '#189fa8',
        '#4fa184',
        '#93a65e',
        '#e97d4c',
        '#e9615e',
        '#e85474'
      ];

      let charCodes = text
        .split('')
        .map(char => char.charCodeAt(0))
        .join('');

      // console.log(charCodes);
      charCodes = parseInt(charCodes, 10);
      if (charCodes < 6400 || charCodes > 12200) return '#939393';
      else return colors[charCodes % colors.length];
    }
  }
};
</script>

<style lang="scss">
.avatar {
  width: 65px;
  height: 65px;
  border-radius: $radius-rounded;

  .letter-mode {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $light-gray;
    color: #ffffff;
    font-size: 2.7rem;
    letter-spacing: 2px;
    justify-content: center;
    display: flex;
    align-items: center;
    font-family: $family-secondary;
  }
}
</style>
